var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 11.6666L16.9417 21.1923C18.0437 21.9638 18.5947 22.3495 19.194 22.4988C19.7233 22.6308 20.277 22.6308 20.8063 22.4988C21.4057 22.3495 21.9567 21.9638 23.0587 21.1923L36.6668 11.6666M11.3335 33.3333H28.6668C31.4672 33.3333 32.8672 33.3333 33.9368 32.7883C34.8777 32.309 35.6425 31.5441 36.1218 30.6033C36.6668 29.5336 36.6668 28.1336 36.6668 25.3333V14.6666C36.6668 11.8664 36.6668 10.4662 36.1218 9.39668C35.6425 8.45586 34.8777 7.69096 33.9368 7.21159C32.8672 6.66663 31.4672 6.66663 28.6668 6.66663H11.3335C8.53323 6.66663 7.1331 6.66663 6.06355 7.21159C5.12273 7.69096 4.35783 8.45586 3.87846 9.39668C3.3335 10.4662 3.3335 11.8664 3.3335 14.6666V25.3333C3.3335 28.1336 3.3335 29.5336 3.87846 30.6033C4.35783 31.5441 5.12273 32.309 6.06355 32.7883C7.1331 33.3333 8.53323 33.3333 11.3335 33.3333Z",
    stroke: "#1F44DD",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.7726bdb2926e49c8d7ff8d14378286cc.svg";
export { ForwardRef as ReactComponent };